import { createActions } from 'redux-actions';

const PREFIX = 'TOUR_FORM';

export const { removeBasket, removeOfferFromBasket, updateOfferInBasket } = createActions({
  removeBasket: (callbacks, basketId) => ({ callbacks, basketId }),
  removeOfferFromBasket: (callbacks, id, basketID, offer) => ({ callbacks, id, basketID, offer }),
  updateOfferInBasket: (callbacks, basketId, offerId, offer) => ({ callbacks, basketId, offerId, offer }),
}, { prefix: PREFIX });
